import React from 'react';

interface CroppedImageProps {
  src: string;
  alt: string;
  className?: string;
  cropTop?: number; // Y position percentage from top (0-100)
  fallbackSrc?: string;
}

export const CroppedImage: React.FC<CroppedImageProps> = ({
  src,
  alt,
  className = '',
  cropTop = 0,
  fallbackSrc,
}) => {
  return (
    <div
      className={`relative overflow-hidden ${className}`}
      style={{ aspectRatio: '16 / 9' }}
    >
      <img
        src={src || fallbackSrc}
        alt={alt}
        className="absolute w-full h-auto select-none"
        style={{
          top: `-${cropTop}%`,
          transform: 'translateZ(0)',
        }}
        loading="lazy"
        draggable={false}
      />
    </div>
  );
};